// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__qER9D","consentsList":"PatientConsents_consentsList___uJJZ","consentsListEmpty":"PatientConsents_consentsListEmpty__1mD87"};